import React, {ReactNode} from 'react'
import TableCustomListNormal from "@ui/tableCustom/containers/list/normal/TableCustomListNormal";
import {HeadColumns, mapperColumnCbType, MapperRowCbType} from "@ui/tableCustom/types/table";
import {IColumnItem} from "@ui/tableCustom/types/columns";
import {IQueryParamsContext} from "@hooks/query/types/queryParams";
import {
    IExportMutateContext,
    IExportParamsContext
} from "@containers/export/containers/buildData/hooks/types/exportParams";

interface IProps<T>{
    data:T[],
    mapperRowCb:MapperRowCbType<T>,
    fullColumns:IColumnItem<T>[],
    params:IQueryParamsContext<T>,
    exportParams:IExportParamsContext<T>,
    exportMutate: IExportMutateContext<T>,
    mapperColumnCb?:mapperColumnCbType<T>,
    headColumns?:HeadColumns<T>
    stickyHeader?:boolean,
    fullScreenMode?:boolean,
    maxHeightScreen?:string,
    lastTableRow?:ReactNode
}

function TableCustomList<T>({
                                data,
                                mapperRowCb,
                                fullColumns,
                                headColumns,
                                params,
                                exportParams,
                                exportMutate,
                                mapperColumnCb,
                                stickyHeader,
                                fullScreenMode,
                                maxHeightScreen,
                                lastTableRow
                            }:IProps<T>){
    return (
        <TableCustomListNormal
            <T>
            data={data}
            mapperRowCb={mapperRowCb}
            fullColumns={fullColumns}
            headColumns={headColumns}
            params={params}
            exportParams={exportParams}
            exportMutate={exportMutate}
            mapperColumnCb={mapperColumnCb}
            stickyHeader={stickyHeader}
            fullScreenMode={fullScreenMode}
            maxHeightScreen={maxHeightScreen}
            lastTableRow={lastTableRow}
        />
    );
}

export default TableCustomList;